var _g, _circle, _g2, _g3, _rect, _circle2, _rect2, _rect3, _g4, _g5, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 623,
    height: 531,
    viewBox: "0 0 623 531",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_411_247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.361 99.037L562.608 135.78C579.102 137.357 591.194 152.006 589.616 168.499L562.012 457.182C560.435 473.676 545.786 485.768 529.292 484.19L145.045 447.448C128.552 445.871 116.46 431.222 118.037 414.728L145.642 126.045C147.219 109.552 161.868 97.4598 178.361 99.037Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.976 153.918L586.951 196.372L562.107 456.187C560.53 472.68 545.881 484.772 529.388 483.195L145.14 446.452C128.647 444.875 116.555 430.226 118.132 413.733L142.976 153.918Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.786,
    cy: 126.01,
    r: 9,
    transform: "rotate(5.46217 176.786 126.01)",
    fill: "#FF605C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.55,
    cy: 130.959,
    r: 9,
    transform: "rotate(5.46217 228.55 130.959)",
    fill: "#00CA4E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.668,
    cy: 128.484,
    r: 9,
    transform: "rotate(5.46217 202.668 128.484)",
    fill: "#FFBD44"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 357.253,
    cy: 255.777,
    r: 36,
    transform: "rotate(5.46217 357.253 255.777)",
    fill: "#D9D9D9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.443 254.827C362.676 255.327 367.324 251.491 367.824 246.258C368.324 241.025 364.488 236.378 359.255 235.877C354.023 235.377 349.375 239.213 348.875 244.446C348.374 249.679 352.211 254.326 357.443 254.827Z",
    fill: "white",
    stroke: "#D0D0D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.648 275.499C372.789 271.565 370.703 268.006 367.691 265.334C364.679 262.663 360.896 261.017 356.888 260.633C352.88 260.25 348.854 261.15 345.39 263.202C341.926 265.254 339.204 268.354 337.615 272.053L373.648 275.499Z",
    fill: "white",
    stroke: "#D0D0D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_411_247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.05 41.5868L487.815 28.1156C504.374 27.5374 518.266 40.4919 518.844 57.0504L528.965 346.874C529.543 363.432 516.588 377.324 500.03 377.902L114.265 391.374C97.7066 391.952 83.8146 378.997 83.2364 362.439L73.1155 72.6155C72.5373 56.0571 85.4918 42.1651 102.05 41.5868Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0927 100.599L519.821 85.0334L528.93 345.874C529.508 362.433 516.554 376.325 499.995 376.903L114.23 390.374C97.6717 390.953 83.7797 377.998 83.2015 361.44L74.0927 100.599Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.992,
    cy: 68.5355,
    r: 9,
    transform: "rotate(-2 103.992 68.5355)",
    fill: "#FF605C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.96,
    cy: 66.7207,
    r: 9,
    transform: "rotate(-2 155.96 66.7207)",
    fill: "#00CA4E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.976,
    cy: 67.6282,
    r: 9,
    transform: "rotate(-2 129.976 67.6282)",
    fill: "#FFBD44"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 188.087,
    y: 241.706,
    width: 228,
    height: 19,
    rx: 6,
    transform: "rotate(-2 188.087 241.706)",
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.784,
    cy: 173.767,
    r: 36,
    transform: "rotate(-2 299.784 173.767)",
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 163.359,
    y: 278.592,
    width: 288,
    height: 19,
    rx: 6,
    transform: "rotate(-2 163.359 278.592)",
    fill: "#EBEBEB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 175.574,
    y: 313.186,
    width: 258,
    height: 19,
    rx: 6,
    transform: "rotate(-2 175.574 313.186)",
    fill: "#EBEBEB"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_411_247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.849 172.799C305.102 172.616 309.212 168.209 309.028 162.955C308.845 157.702 304.438 153.592 299.184 153.775C293.931 153.959 289.821 158.366 290.004 163.619C290.188 168.873 294.595 172.983 299.849 172.799Z",
    fill: "white",
    stroke: "#D0D0D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.6 191.192C317.238 187.403 314.707 184.145 311.374 181.887C308.04 179.629 304.076 178.488 300.052 178.629C296.028 178.77 292.153 180.184 288.985 182.669C285.817 185.154 283.52 188.581 282.425 192.455L318.6 191.192Z",
    fill: "white",
    stroke: "#D0D0D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_411_247)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.95706,
    y: 139.036,
    width: 446,
    height: 350,
    rx: 30,
    transform: "rotate(-4.5 9.95706 139.036)",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5077 196.857L459.133 161.864L479.611 422.06C480.911 438.577 468.574 453.021 452.057 454.321L67.2468 484.606C50.7293 485.906 36.2855 473.57 34.9855 457.052L14.5077 196.857Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.9799,
    cy: 163.52,
    r: 9,
    transform: "rotate(-4.5 42.9799 163.52)",
    fill: "#FF605C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.8196,
    cy: 159.441,
    r: 9,
    transform: "rotate(-4.5 94.8196 159.441)",
    fill: "#00CA4E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.8998,
    cy: 161.48,
    r: 9,
    transform: "rotate(-4.5 68.8998 161.48)",
    fill: "#FFBD44"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1322 211.359L145.478 203.461C148.781 203.201 151.67 205.669 151.93 208.972L161.738 333.587C161.998 336.89 159.53 339.779 156.227 340.039L55.8811 347.936C52.5776 348.196 49.6889 345.729 49.4289 342.426L39.6215 217.811C39.3615 214.507 41.8287 211.619 45.1322 211.359Z",
    fill: "#F9F9F9",
    stroke: "#D9D9D9",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M335.34 188.519L435.685 180.622C438.989 180.362 441.878 182.829 442.138 186.132L451.945 310.747C452.205 314.051 449.738 316.939 446.434 317.199L346.089 325.097C342.785 325.357 339.896 322.889 339.636 319.586L329.829 194.971C329.569 191.668 332.036 188.779 335.34 188.519Z",
    fill: "#F9F9F9",
    stroke: "#D9D9D9",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190.236 199.939L290.582 192.041C293.885 191.781 296.774 194.249 297.034 197.552L303.154 275.312C303.414 278.615 300.947 281.504 297.643 281.764L197.297 289.661C193.994 289.921 191.105 287.454 190.845 284.151L184.725 206.391C184.465 203.088 186.932 200.199 190.236 199.939Z",
    fill: "#F9F9F9",
    stroke: "#D9D9D9",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3918 379.838L158.738 371.94C162.041 371.68 164.93 374.148 165.19 377.451L172.8 474.152L60.4916 482.991L52.8811 386.29C52.6211 382.986 55.0883 380.098 58.3918 379.838Z",
    fill: "#F9F9F9",
    stroke: "#D9D9D9",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M348.599 356.998L448.945 349.101C452.248 348.841 455.137 351.308 455.397 354.611L463.008 451.312L350.699 460.151L343.089 363.45C342.829 360.147 345.296 357.258 348.599 356.998Z",
    fill: "#F9F9F9",
    stroke: "#D9D9D9",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M199.808 321.563L300.154 313.665C303.457 313.405 306.346 315.873 306.606 319.176L317.904 462.732L205.595 471.571L194.297 328.015C194.037 324.711 196.505 321.823 199.808 321.563Z",
    fill: "#F9F9F9",
    stroke: "#D9D9D9",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_411_247",
    x: 113.898,
    y: 96.8986,
    width: 479.856,
    height: 393.43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_411_247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_411_247",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_411_247",
    x: 69.0969,
    y: 26.0969,
    width: 463.886,
    height: 371.295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_411_247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_411_247",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_411_247",
    x: 8.21674,
    y: 104.303,
    width: 475.566,
    height: 387.394,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_411_247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_411_247",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white",
    transform: "translate(338.253 233.869) rotate(5.46217)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_411_247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white",
    transform: "translate(278.099 154.512) rotate(-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty_state.fc15d0fc60bdb4c6fa20c5f6afde510d.svg";
export { ForwardRef as ReactComponent };